import type { AddonNames, PlanNames, ProductNames } from '#pricing/types/product';

export const ADDON_CODES: Record<
  AddonNames,
  | 'accounting'
  | 'accounts_receivable'
  | 'accounts_payable'
  | 'expense_spend_management'
  | 'cash_flow_management'
  | 'team_spend_controls'
  | 'invoice_automation'
  | 'project_tracking'
> = {
  Accounting: 'accounting',
  AccountsReceivable: 'accounts_receivable',
  AccountsPayable: 'accounts_payable',
  ExpenseSpendManagement: 'expense_spend_management',
  CashFlowManagement: 'cash_flow_management',
  TeamSpendControls: 'team_spend_controls',
  InvoiceAutomation: 'invoice_automation',
  ProjectTracking: 'project_tracking',
} as const;

export const PRICE_PLAN_CODES: Record<
  PlanNames,
  | 'solo_basic_2024'
  | 'solo_smart_2024'
  | 'solo_premium_2024'
  | 'team_essential_2024'
  | 'team_business_2024'
  | 'team_enterprise_2024'
  | 'solo_payg_2026'
  | 'light'
> = {
  SoloBasic: 'solo_basic_2024',
  SoloSmart: 'solo_smart_2024',
  SoloPremium: 'solo_premium_2024',
  TeamEssential: 'team_essential_2024',
  TeamBusiness: 'team_business_2024',
  TeamEnterprise: 'team_enterprise_2024',
  Starter: 'solo_payg_2026',
  Light: 'light',
} as const;

export const ADDON_GROUP_CODES: Record<
  AddonNames,
  | 'accounts_receivable'
  | 'accounts_payable'
  | 'expense_spend_management'
  | 'cash_flow_management'
  | 'team_spend_controls'
  | 'invoice_automation'
  | 'project_tracking'
  | 'accounting'
> = {
  AccountsReceivable: 'accounts_receivable',
  AccountsPayable: 'accounts_payable',
  ExpenseSpendManagement: 'expense_spend_management',
  CashFlowManagement: 'cash_flow_management',
  TeamSpendControls: 'team_spend_controls',
  InvoiceAutomation: 'invoice_automation',
  ProjectTracking: 'project_tracking',
  Accounting: 'accounting',
} as const;

export const PRODUCT_CODES: Record<
  ProductNames,
  | 'solo_basic_2024'
  | 'solo_smart_2024'
  | 'solo_premium_2024'
  | 'team_essential_2024'
  | 'team_business_2024'
  | 'team_enterprise_2024'
  | 'accounts_receivable'
  | 'accounts_payable'
  | 'expense_spend_management'
  | 'cash_flow_management'
  | 'team_spend_controls'
  | 'invoice_automation'
  | 'project_tracking'
  | 'accounting'
  | 'solo_payg_2026'
  | 'light'
> = {
  ...ADDON_CODES,
  ...PRICE_PLAN_CODES,
} as const;

export const PRICE_PLAN_TRAITS: Record<
  'Active' | 'FreeTrial' | 'Promo',
  'active' | 'free_trial' | 'promo'
> = {
  Active: 'active',
  FreeTrial: 'free_trial',
  Promo: 'promo',
} as const;

export const PRODUCT_TEST_IDS: Record<
  ProductNames,
  | 'solo_basic_2024_id'
  | 'solo_smart_2024_id'
  | 'solo_premium_2024_id'
  | 'team_essential_2024_id'
  | 'team_business_2024_id'
  | 'team_enterprise_2024_id'
  | 'accounts_receivable_id'
  | 'accounts_payable_id'
  | 'expense_spend_management_id'
  | 'cash_flow_management_id'
  | 'team_spend_controls_id'
  | 'invoice_automation_id'
  | 'project_tracking_id'
  | 'accounting_id'
  | 'starter_id'
  | 'light_id'
> = {
  SoloBasic: 'solo_basic_2024_id',
  SoloSmart: 'solo_smart_2024_id',
  SoloPremium: 'solo_premium_2024_id',
  TeamEssential: 'team_essential_2024_id',
  TeamBusiness: 'team_business_2024_id',
  TeamEnterprise: 'team_enterprise_2024_id',
  Accounting: 'accounting_id',
  AccountsReceivable: 'accounts_receivable_id',
  AccountsPayable: 'accounts_payable_id',
  ExpenseSpendManagement: 'expense_spend_management_id',
  CashFlowManagement: 'cash_flow_management_id',
  TeamSpendControls: 'team_spend_controls_id',
  InvoiceAutomation: 'invoice_automation_id',
  ProjectTracking: 'project_tracking_id',
  Starter: 'starter_id',
  Light: 'light_id',
} as const;

export const PRODUCT_GROUP_CODES: Record<
  ProductNames,
  | 'solo_basic'
  | 'solo_smart'
  | 'solo_premium'
  | 'team_essential'
  | 'team_business'
  | 'team_enterprise'
  | 'accounting'
  | 'accounts_receivable'
  | 'accounts_payable'
  | 'expense_spend_management'
  | 'cash_flow_management'
  | 'team_spend_controls'
  | 'invoice_automation'
  | 'project_tracking'
  | 'solo_payg'
  | 'light'
> = {
  SoloBasic: 'solo_basic',
  SoloSmart: 'solo_smart',
  SoloPremium: 'solo_premium',
  TeamEssential: 'team_essential',
  TeamBusiness: 'team_business',
  TeamEnterprise: 'team_enterprise',
  Accounting: 'accounting',
  AccountsReceivable: 'accounts_receivable',
  AccountsPayable: 'accounts_payable',
  ExpenseSpendManagement: 'expense_spend_management',
  CashFlowManagement: 'cash_flow_management',
  TeamSpendControls: 'team_spend_controls',
  InvoiceAutomation: 'invoice_automation',
  ProjectTracking: 'project_tracking',
  Starter: 'solo_payg',
  Light: 'light',
} as const;
